module.exports = __webpack_public_path__ + "static/media/axis_of_polarization_00247.14bb0a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/en/axis_of_polarization_00247.png
// module id = 977
// module chunks = 0